enum SSOProvider {
  Ping = "PingProvider",
}

export default SSOProvider;
